import api from '~/services/api';

const endPoint = 'states';

// GET ALL
export const getStates = async (params, route = '') => {
  try {
    const { data } = await api.get(`/${endPoint}/${route}`, params);
    return data.data;
  } catch (error) {
    throw error;
  }
};
